import { Add, AddCircle } from '@mui/icons-material';
import { Button, Fab, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NewUserButton({ onClick }) {
  const { t } = useTranslation('users');
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (!smallScreen)
    return (
      <Button variant="contained" startIcon={<AddCircle />} onClick={onClick}>
        {t('newUser')}
      </Button>
    );

  return (
    <Fab
      color="primary"
      aria-label="add"
      onClick={onClick}
      sx={{ position: 'fixed', bottom: 16, right: 16 }}
    >
      <Add />
    </Fab>
  );
}
